"use client";

import { useCallback } from "react";
import { track } from "../../core/client";

/**
 * 포트폴리오 생성 추적 훅
 */
export function usePortfolioCreate() {
    const trackCreate = useCallback(
        (portfolioId: string, assetCount?: number, seedAmount?: number) => {
            track("portfolio_create", {
                portfolio_id: portfolioId,
                asset_count: assetCount || undefined,
                seed_amount: seedAmount || undefined,
            });
        },
        []
    );

    return { trackCreate };
}

/**
 * 포트폴리오 편집 추적 훅
 */
export function usePortfolioEdit() {
    const trackEdit = useCallback(
        (
            portfolioId: string,
            addedCount?: number,
            removedCount?: number,
            rebalanced?: boolean
        ) => {
            track("portfolio_edit", {
                portfolio_id: portfolioId,
                added_count: addedCount || undefined,
                removed_count: removedCount || undefined,
                rebalanced: rebalanced || undefined,
            });
        },
        []
    );

    return { trackEdit };
}

/**
 * 포트폴리오 추적 훅 (통합)
 * @deprecated 개별 훅 사용을 권장합니다 (usePortfolioCreate, usePortfolioEdit)
 */
export function usePortfolioTracking() {
    const trackCreate = useCallback(
        (portfolioId: string, assetCount?: number, seedAmount?: number) => {
            track("portfolio_create", {
                portfolio_id: portfolioId,
                asset_count: assetCount || undefined,
                seed_amount: seedAmount || undefined,
            });
        },
        []
    );

    const trackEdit = useCallback(
        (
            portfolioId: string,
            addedCount?: number,
            removedCount?: number,
            rebalanced?: boolean
        ) => {
            track("portfolio_edit", {
                portfolio_id: portfolioId,
                added_count: addedCount || undefined,
                removed_count: removedCount || undefined,
                rebalanced: rebalanced || undefined,
            });
        },
        []
    );

    return {
        trackCreate,
        trackEdit,
    };
}

